/**
 * How many products a mall shop unit displays (window + wall + table slots).
 * The API returns only this many per store: full catalogs are pure waste on
 * the wire (Animal Dander's 521 products were 2.5 MB of JSON for 20 display
 * slots, times 39 stores on the loading-screen preload).
 */
export const PRODUCTS_PER_SHOP = 20;
/**
 * Stable partition then cap: in-stock first (keeping the incoming
 * bestseller ranking within each group), out-of-stock only filling leftover
 * slots. Mirrors exactly what the client's shop units render, so the capped
 * response shows the same products the full catalog would have.
 */
/**
 * The sold count printed under a product, on tiles and in the product panel.
 * Products absent from the map have never sold (the upstream map carries only
 * sold products), which reads better as an invitation than as a zero. Absence
 * also covers a product with no handle and the whole map being empty because
 * the stats section was unreachable, both of which mean "we don't know".
 */
export function soldLine(product, unitsSold) {
    const handle = product.handle;
    const units = handle === undefined ? 0 : (unitsSold[handle] ?? 0);
    if (units <= 0) {
        return "Be the first";
    }
    return units === 1 ? "1 sold" : `${units} sold`;
}
export function capProductsForMall(products, limit = PRODUCTS_PER_SHOP) {
    const inStock = products.filter((p) => p.availability === "in_stock");
    const outOfStock = products.filter((p) => p.availability !== "in_stock");
    return [...inStock, ...outOfStock].slice(0, limit);
}
//# sourceMappingURL=products.js.map